export default __webpack_public_path__ + "static/media/DSCN8371.5b09340a.JPG";